import { env } from 'src/config/env';
import { isFunnelPath } from 'src/config/funnelWebBase';
import { initDebugMode, isDebugMode } from 'src/contexts/DebugContext';
import { isNative } from 'src/utils/platform';
import { readStoredItem, writeStoredItem } from 'src/utils/storageManager';

export type AppTree = 'funnel' | 'web' | 'native';

const FORCE_WEB_ROUTER_KEY = 'forceWebRouter';

const isForcedWebRouter = (): boolean => {
  const param = new URLSearchParams(window.location.search).get(
    FORCE_WEB_ROUTER_KEY,
  );
  if (param === 'true') writeStoredItem(FORCE_WEB_ROUTER_KEY, 'true');
  return param === 'true' || readStoredItem(FORCE_WEB_ROUTER_KEY) === 'true';
};

export const selectAppTree = (): AppTree => {
  initDebugMode();
  if (isFunnelPath(window.location.pathname)) return 'funnel';
  if (isForcedWebRouter()) return 'web';
  if (isNative() || isDebugMode() || env.isDev || env.isCi) return 'native';
  return 'web';
};
